// src/hooks/useTraslados.js
import { useState } from "react";
import { guardarLote } from "../../programacionLote";
import { message } from "antd";

const useTraslados = () => {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [totalTraslados, setTotalTraslados] = useState(0);

  const confirmarAgendar = async (traslados, onClose, onCloseParentDialog) => {
    if (traslados.length === 0) {
      message.error("No se generaron traslados. Revisa la selección de días.");
      return;
    }

    setLoading(true);
    setTotalTraslados(traslados.length);
    setProgress(0);

    try {
      await guardarLote(traslados);
      setProgress(100);

      message.success("Traslados agendados exitosamente.");
      onClose();
      onCloseParentDialog();
    } catch (error) {
      console.error("Error al agendar traslados:", error);
      message.error(error.response?.data?.message || "No se recibió confirmación. Reintente sin cambiar los datos para consultar el resultado de la misma operación.");
    } finally {
      setLoading(false);
    }
  };

  return { loading, progress, totalTraslados, confirmarAgendar };
};

export default useTraslados;
